// import React, { useState, useEffect, Fragment } from "react";
// import axios from "axios";
// import DataTable from "react-data-table-component";
// import {
//   Button,
//   Modal,
//   ModalBody,
//   ModalFooter,
//   Spinner,
//   FormGroup,
//   Label,
//   Input,
// } from "reactstrap";
// import { useSelector } from "react-redux";
// import apiRequest from "../../utils/apiRequest";
// import { Breadcrumbs } from "../../AbstractElements";

// const Zips = () => {
//   const [orders, setOrders] = useState([]);
//   const [subAdmins, setSubAdmins] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [statusModalOpen, setStatusModalOpen] = useState(false);
//   const [assignModalOpen, setAssignModalOpen] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [selectedSubAdmin, setSelectedSubAdmin] = useState("");
//   const [taskDescription, setTaskDescription] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [totalRows, setTotalRows] = useState(0); // To keep track of total rows for pagination
//   const token = useSelector((state) => state.auth.userToken);

//   const fetchOrders = async (page = 1, rows = 10) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/gallery/admin`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           params: { page, limit: rows },
//         }
//       );
//       console.log("🚀 ~ fetchOrders ~ response:", response.data);
//       setOrders(
//         response.data.map((order) => ({
//           user: order.user,
//           folderName: order.folderName,
//           floorVideos: order.floorVideos || [],
//           floorZips: order.floorZips || [],
//         }))
//       );
//       setTotalRows(response.data.total);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching orders:", error);
//       setLoading(false);
//     }
//   };

//   const fetchSubAdmins = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/admin/active-subadmins`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setSubAdmins(response.data.subAdmins);
//     } catch (error) {
//       console.error("Error fetching sub-admins:", error);
//     }
//   };

//   useEffect(() => {
//     fetchOrders(currentPage, rowsPerPage);
//     fetchSubAdmins();
//   }, [currentPage, rowsPerPage, token]);

//   const handleStatusUpdate = async () => {
//     try {
//       setLoading(true);
//       const data = {
//         folderId: selectedOrder.folder._id,
//         driveId: selectedOrder.driveFolderId,
//       };
//       await apiRequest(
//         "post",
//         `${process.env.REACT_APP_API_BASE_URL}/orders/orderComplete`,
//         data,
//         token
//       );
//       fetchOrders(currentPage, rowsPerPage); // Refresh orders after status update
//       setStatusModalOpen(false);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error updating order status:", error);
//       setLoading(false);
//     }
//   };

//   const handleTaskAssignment = async () => {
//     try {
//       setLoading(true);
//       const data = {
//         subAdminId: selectedSubAdmin,
//         orderId: selectedOrder._id,
//         taskDescription: taskDescription,
//       };
//       await apiRequest(
//         "post",
//         `${process.env.REACT_APP_API_BASE_URL}/admin/assign`,
//         data,
//         token
//       );
//       fetchOrders(currentPage, rowsPerPage); // Refresh orders after assignment
//       setAssignModalOpen(false);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error assigning task:", error);
//       setLoading(false);
//     }
//   };

//   const handleStatusModal = (order) => {
//     setSelectedOrder(order);
//     setStatusModalOpen(true);
//   };

//   const columns = [
//     {
//       name: "User ID",
//       selector: (row) => row.user,
//       sortable: true,
//     },
//     {
//       name: "Folder Name",
//       selector: (row) => row.folderName,
//       sortable: true,
//     },
//     {
//       name: "Preview Video",
//       cell: (row) =>
//         row.floorVideos && row.floorVideos.length > 0 ? (
//           <video width="120" height="90" controls>
//             <source
//               src={row.floorVideos[0].url}
//               type={`video/${row.floorVideos[0].format}`}
//             />
//             Your browser does not support the video tag.
//           </video>
//         ) : (
//           <span>No Video</span>
//         ),
//     },
//     {
//       name: "Download ZIP",
//       cell: (row) =>
//         row.floorZips && row.floorZips.length > 0 ? (
//           <Button
//             color="info"
//             onClick={() => window.open(row.floorZips[0].zipUrl, "_blank")}
//           >
//             Download ZIP
//           </Button>
//         ) : (
//           <span>No ZIP</span>
//         ),
//     },
//   ];

//   return (
//     <div>
//       <Breadcrumbs mainTitle="Zips" parent="Dashboard" title="Zips" />
//       <DataTable
//         columns={columns}
//         data={orders}
//         pagination
//         paginationServer
//         paginationPerPage={rowsPerPage}
//         paginationTotalRows={totalRows}
//         onChangePage={(page) => setCurrentPage(page)}
//         onChangeRowsPerPage={(rows) => setRowsPerPage(rows)}
//         progressPending={loading}
//       />
//     </div>
//   );
// };

// export default Zips;

import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useSelector } from "react-redux";
import apiRequest from "../../utils/apiRequest";
import { Breadcrumbs } from "../../AbstractElements";

const Zips = () => {
  const [orders, setOrders] = useState([]);
  const [subAdmins, setSubAdmins] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  console.log("🚀 ~ Zips ~ selectedOrder:", selectedOrder)
  const [selectedSubAdmin, setSelectedSubAdmin] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0); // To keep track of total rows for pagination
  const [modalImageUrl, setModalImageUrl] = useState(null); // For preview or editing image
  console.log("🚀 ~ Zips ~ modalImageUrl:", modalImageUrl)
  const token = useSelector((state) => state.auth.userToken);

  const fetchOrders = async (page = 1, rows = 10) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/gallery/admin`,
        {
          headers: { Authorization: `Bearer ${token}` },
        //   params: { page, limit: rows },
        }
      );
      console.log("🚀 ~ fetchOrders ~ response:", response.data);
      setOrders(
        response.data.map((order) => ({
          user: order.user,
          _id: order._id,
          folderName: order.folderName,
          cubicassaImage: order.cubicassaImage, // assuming cubicassaImage is returned
          floorVideos: order.floorVideos || [],
          floorZips: order.floorZips || [],
        }))
      );
      setTotalRows(response.data.total);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setLoading(false);
    }
  };

  const fetchSubAdmins = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/active-subadmins`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSubAdmins(response.data.subAdmins);
    } catch (error) {
      console.error("Error fetching sub-admins:", error);
    }
  };

  useEffect(() => {
    fetchOrders(currentPage, rowsPerPage);
    fetchSubAdmins();
  }, [currentPage, rowsPerPage, token]);



  const [image, setImage] = useState(null); // Store the selected image

  const handleImageUpdate = async (event) => {
    setImage(event.target.files[0]);
  };
  const handleImageModal = (order) => {
    console.log("🚀 ~ handleImageModal ~ order:", order)
    setSelectedOrder(order);
    setModalImageUrl(order.cubicassaImage || ""); // Set the image URL or empty string
  };
  const handleUpdateImage = async () => {
    if (!image) return; // If no image is selected, return early.

    const formData = new FormData();
    formData.append("cubicassaImage", image);

    setLoading(true);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/gallery/admin/${selectedOrder._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Assuming the response contains the updated image URL
      fetchOrders();
      setModalImageUrl(null) // Refresh the orders list
     
    } catch (error) {
      console.error("Error updating image:", error);
    } finally {
      setLoading(false);
    }
  };
  const columns = [
    {
      name: "User ID",
      selector: (row) => row.user,
      sortable: true,
    },
    {
      name: "Folder Name",
      selector: (row) => row.folderName,
      sortable: true,
    },
    {
      name: "Preview Video",
      cell: (row) =>
        row.floorVideos && row.floorVideos.length > 0 ? (
          <video width="120" height="90" controls>
            <source
              src={row.floorVideos[0].url}
              type={`video/${row.floorVideos[0].format}`}
            />
            Your browser does not support the video tag.
          </video>
        ) : (
          <span>No Video</span>
        ),
    },
    {
      name: "Download ZIP",
      cell: (row) =>
        row.floorZips && row.floorZips.length > 0 ? (
          <Button
            color="info"
            onClick={() => window.open(row.floorZips[0].zipUrl, "_blank")}
          >
            Download ZIP
          </Button>
        ) : (
          <span>No ZIP</span>
        ),
    },
    {
      name: "Cubicassa Image",
      cell: (row) => (
        <Button color="primary" onClick={() => handleImageModal(row)}>
          {row.cubicassaImage ? "Preview/Edit Image" : "Add Image"}
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Breadcrumbs mainTitle="Zips" parent="Dashboard" title="Zips" />
      <DataTable
        columns={columns}
        data={orders}
        pagination
        paginationServer
        paginationPerPage={rowsPerPage}
        paginationTotalRows={totalRows}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(rows) => setRowsPerPage(rows)}
        progressPending={loading}
      />
      <Modal isOpen={modalImageUrl !== null} toggle={() => setModalImageUrl(null)}>
      <ModalBody>
        {modalImageUrl ? (
          <Fragment>
            <img
              src={modalImageUrl}
              alt="Cubicassa Image Preview"
              style={{ width: "100%" }}
            />
            <FormGroup>
              <Label for="imageUpload">Change Image</Label>
              <Input
                type="file"
                id="imageUpload"
                onChange={handleImageUpdate}
              />
            </FormGroup>
          </Fragment>
        ) : (
          <Fragment>
            <FormGroup>
              <Label for="imageUpload">Change Image</Label>
              <Input
                type="file"
                id="imageUpload"
                onChange={handleImageUpdate}
              />
            </FormGroup>
          </Fragment>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setModalImageUrl(null)}>
          Close
        </Button>
        <Button
          color="primary"
          onClick={handleUpdateImage}
          disabled={loading || !image} // Disable button if loading or no image is selected
        >
          {loading ? <Spinner size="sm" /> : "Update"}
        </Button>
      </ModalFooter>
    </Modal>
    </div>
  );
};

export default Zips;
